import {
    Component
} from '@angular/core';
import {
    ChangeDetectorRef
} from '@angular/core';
import {
    ApperyioHelperService
} from '../../scripts/apperyio/apperyio_helper';
import {
    ApperyioMappingHelperService
} from '../../scripts/apperyio/apperyio_mapping_helper';
import {
    ExportedClass as NeurService
} from '../../scripts/custom/NeurService';
import {
    SEASON_COLORS
} from '../../../app/scripts/custom/NeurConstants';
import {
    SAFETY_INDEX_COLORS
} from '../../../app/scripts/custom/NeurConstants';
import {
    SAFETY_INDEX_TEXTS
} from '../../../app/scripts/custom/NeurConstants';
import {
    $aio_empty_object
} from '../../scripts/interfaces';
import {
    Input
} from '@angular/core';
import {
    Output
} from '@angular/core';
import {
    EventEmitter
} from '@angular/core';
import {
    ViewChild
} from '@angular/core';
@Component({
    templateUrl: 'PlaceKeyInfoCard.html',
    selector: 'component-place-key-info-card',
    styleUrls: ['PlaceKeyInfoCard.css', 'PlaceKeyInfoCard.scss']
})
export class PlaceKeyInfoCard {
    public monthAbbreviations: any;
    public season_colors: any;
    public safety_index_colors: any;
    public safety_index_norm: number;
    public safety_index_texts: any;
    public safetyArrowLeft: number;
    public screenOrientation: any;
    public $a: ApperyioHelperService;
    public $v: {
        [name: string]: any
    };
    public aioChangeDetector: ChangeDetectorRef;
    public currentItem: any = null;
    public mappingData: any = {};
    public __getMapping(_currentItem, property, defaultValue, isVariable?, isSelected?) {
        return this.$aio_mappingHelper.getMapping(this.mappingData, _currentItem, property, defaultValue, isVariable, isSelected);
    }
    public __isPropertyInMapping(_currentItem, property) {
        return this.$aio_mappingHelper.isPropertyInMapping(this.mappingData, _currentItem, property);
    }
    public __setMapping(data: any = {}, keyName: string, propName?: string): void {
        const changes = data.detail || {};
        if (propName) {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes[propName]);
        } else {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes.value);
        }
        this.$aio_changeDetector.detectChanges();
    }
    public __bindedMethods: any = {};
    @Input() public place: any;
    ngAfterViewInit(): any {
        this.updateSafetyArrowLeft();
    }
    updateSafetyArrowLeft(): any {
        if (this.place.safety_index != undefined && this.place.safety_index != null) {
            this.safety_index_norm = Math.floor(Math.floor(this.place.safety_index) / 26);
            setTimeout(() => {
                const barElement = document.getElementById('idSafetyBar') as HTMLElement;
                const boundingRect = barElement.getBoundingClientRect();
                const arrowElement = document.getElementById('idSafetyArrow') as HTMLElement;
                const arrowRect = arrowElement.getBoundingClientRect();
                this.safetyArrowLeft = boundingRect.width * this.place.safety_index / 100 - arrowRect.width / 2;
            });
        }
    }
    ngOnInit(): any {
        this.screenOrientation = this.neurService.screen_orientation;
        let self = this;
        this.neurService.getScreenOrientation().subscribe((orientation) => {
            self.screenOrientation = self.neurService.screen_orientation;
            self.updateSafetyArrowLeft();
        });
    }
    constructor(public Apperyio: ApperyioHelperService, private $aio_mappingHelper: ApperyioMappingHelperService, private $aio_changeDetector: ChangeDetectorRef, public neurService: NeurService) {
        this.$a = this.Apperyio;
        this.$v = this.Apperyio.vars;
        this.monthAbbreviations = neurService.monthAbbreviations;
        this.season_colors = SEASON_COLORS;
        this.safety_index_colors = SAFETY_INDEX_COLORS;
        this.safety_index_texts = SAFETY_INDEX_TEXTS;
        this.safetyArrowLeft = 0;
        this.aioChangeDetector = this.$aio_changeDetector;
    }
}